import { render } from "./HeroiconsOutlineGlobeAlt.vue?vue&type=template&id=6b4c19e2"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineGlobeAlt.vue"]])

export default __exports__